import { createMiddleware } from 'redux-beacon';
import { GoogleTagManager } from 'redux-beacon/targets/google-tag-manager';
import { logger } from 'redux-beacon/extensions/logger';

import { FETCH_AD_FAILED, SAVE_APPLY_FAILED, SAVE_APPLY_SUCCESS } from '../AdPage/constants';
import { SAVE_ALERT_FAILED, SAVE_ALERT_SUCCESS } from '../Alerts/email/actionTypes';
import { FETCH_INDEX_SEO_FAILED } from '../Index/constants';
import { TRACK_EVENT, LOCATION_CHANGE, RETRACK_ADS_IMPRESSIONS } from './constants';
import {
  SET_SEARCH_PARAMS,
  FETCH_ADS_FAILED,
  FETCH_ADS_SUCCESS,
  TRACKING_RELATED_ADS_MODAL,
} from '../Serp/constants';
import * as definitions from './eventDefinitions';

// Use logger only on client side (it fails on server side because it use console.group)
const useLogger =
  process.env.NODE_ENV !== 'production' && typeof window !== 'undefined' ? { logger } : undefined;

// Map the event to a Redux action
const eventsMap = {
  [TRACK_EVENT]: definitions.customEvent,
  [LOCATION_CHANGE]: definitions.pageView,
  [SET_SEARCH_PARAMS]: definitions.filtersChange,
  [FETCH_ADS_SUCCESS]: definitions.adImpressions,
  [RETRACK_ADS_IMPRESSIONS]: definitions.adImpressions,
  [SAVE_ALERT_SUCCESS]: definitions.saveAlert,
  [SAVE_APPLY_SUCCESS]: definitions.saveApply,
  [TRACKING_RELATED_ADS_MODAL]: definitions.relatedAdsModalImpressions,

  // Failed events
  [FETCH_AD_FAILED]: definitions.errorEvent,
  [SAVE_APPLY_FAILED]: definitions.errorEvent,
  [FETCH_INDEX_SEO_FAILED]: definitions.errorEvent,
  [FETCH_ADS_FAILED]: definitions.errorEvent,
  [SAVE_ALERT_FAILED]: definitions.errorEvent,
};

// Create the middleware
export default createMiddleware(eventsMap, GoogleTagManager(), useLogger);



// WEBPACK FOOTER //
// ./app/tracking/index.js